module.exports = __webpack_public_path__ + "static/media/bottom.442ae781.svg";